export const app_colors = {
  background_color: '#fafafa',
};
